import UiElement from '../../../shared/ui-element/ui-element';

import './category-tabs.scss';

class CategoryTabs extends UiElement {
  ui = {
    categoryBtn: '.js-category-tabs-open',
    categoryNav: '.js-category-tabs',
  };

  events = {
    'click @ui.categoryBtn': 'handleCategoryClick',
  };

  static activeCategoryClass = 'category-tabs_opened';

  handleCategoryClick() {
    this.ui.categoryNav.classList.toggle(CategoryTabs.activeCategoryClass);
  }
}

export default CategoryTabs;
